import React, { useEffect, useRef, useState } from "react";

// Custom Lazy Image Component
const LazyImage = ({ src, alt, width, height, className, bg }) => {
  const [isInView, setIsInView] = useState(false); // Track if image is in viewport
  const imgRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsInView(true); // Image is in viewport
            observer.unobserve(entry.target); // Stop observing once the image is loaded
          }
        });
      },
      {
        root: null, // Use the viewport as the root
        rootMargin: "0px", // Load image as soon as it enters the viewport
        threshold: 0.1, // Trigger when 10% of the image is visible
      }
    );

    if (imgRef.current) {
      observer.observe(imgRef.current); // Start observing the image
    }

    return () => {
      if (imgRef.current) {
        observer.unobserve(imgRef.current); // Clean up the observer on unmount
      }
    };
  }, []);

  return (
    <div
      ref={imgRef}
      style={{
        width: width ? `${width}` : "100%",
        height: height ? `${height}` : "100%",
        backgroundColor: bg === "none" ? "transparent" : "#f0f0f0", // Placeholder background
      }}
    >
      {isInView && (
        <img
          src={src}
          alt={alt}
          width={width ? `${width}` : "100%"}
          height={height ? `${height}` : "100%"}
          className={className}
        />
      )}
    </div>
  );
};

export default LazyImage;
